import React, { Component } from "react";
import ProductPickerRadioSelect from "./product-picker-radio-select";
import SpinnerButton from "ReactComponents/Shared/FormInputs/spinner-button";
import NoticeList from "ReactComponents/Basket/notice-list";
import * as priceConfigUtils from "ReactComponents/Shared/Utils/priceConfigUtils";
import Modal from "../../Modal/modal";
import * as tracking from "ReactComponents/Shared/Utils/tracking";
import ProductPickerSelectedTypelist from "./product-picker-selected-typelist";
import DeliveryCostsModalButton from "ReactComponents/DeliveryCostsModalButton/delivery-costs-modal-button";
import LoginModal from "ReactComponents/LoginModal/login-modal";
import { ADD_TO_BASKET_LOCALSTORAGE_KEY, SINGLE_USER_LICENSE_CODE } from "../../../constants";

class ProductPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ghModalOpen: false,
            loginModalOpen: false
        };

        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.productInBasket = this.productInBasket.bind(this);
        this.getUpdateInButtonState = this.getUpdateInButtonState.bind(this);
        this.toggleLoginModal = this.toggleLoginModal.bind(this);
        this.onLoginAndAddToBasket = this.onLoginAndAddToBasket.bind(this);
    }

    isLoading() {
        if (this.props.currentProduct) {
            return this.props.isAdding.indexOf(this.props.currentProduct.Id) != -1;
        }
    }

    onChangeHandler(e) {
        this.props.onChange(e);
    }

    toggleLoginModal(open) {
        this.setState({
            loginModalOpen: open
        });
    }

    submitHandler() {
        this.props.addToBasket();
    }

    productInBasket(productId) {
        const basketHasItems =
            this.props.basket && this.props.basket.BasketItems && this.props.basket.BasketItems.length > 0;
        const productInBasket =
            basketHasItems && this.props.basket.BasketItems.find(item => item.Isbn == productId);

        return productInBasket || false;
    }

    getUpdateInButtonState(currentProduct, basketVersionOfProduct, currentPriceConfig) {
        const labels = this.props.Labels.ProductPickerLabels;
        const putInBasket = { disabled: false, label: labels.PutInBasketText };
        const inBasket = { disabled: true, label: labels.IsInBasketText };
        const canUpdateBasket = { disabled: false, label: labels.UpdateBasketText };
        const noClassesSelected = { disabled: true, label: labels.NoClassesSelectedText };
        const noPeriodSelected = { disabled: true, label: labels.NoPeriodSelectedText };

        const hasPeriodOptions =
            currentPriceConfig.PeriodOptions && currentPriceConfig.PeriodOptions.length > 1;
        const isPhysicalProduct = currentPriceConfig.AccessFormCode == 0;
        const sameAccessFormInBasket =
            currentPriceConfig.AccessFormCode == basketVersionOfProduct.AccessFormCode;

        const checkPeriodOptions = () => {
            const currentPeriod = currentPriceConfig.PeriodOptions.filter(item => {
                return item.Selected;
            })[0];

            const sameUnitTypeCode =
                currentPeriod && currentPeriod.UnitTypeCode == basketVersionOfProduct.PeriodUnitTypeCode;
            const sameUnitValue =
                currentPeriod && currentPeriod.UnitValue == basketVersionOfProduct.PeriodUnitValue;
            const samePeriod = sameUnitTypeCode && sameUnitValue;
            const sameAmountAsInBasket = basketVersionOfProduct.Count == this.props.amount;

            if (!currentPeriod) {
                // No period selected
                //console.log("checkPeriodOptions - No period selected")
                return noPeriodSelected;
            } else if (!currentProduct.IsInBasket) {
                // Not in basket
                //console.log("checkPeriodOptions - Not in basket")
                return putInBasket;
            } else if (sameAccessFormInBasket && samePeriod && sameAmountAsInBasket) {
                // Same license type as in basket && same period && same amount
                //console.log("checkPeriodOptions - Same license type as in basket && samePeriod && same amount")
                return inBasket;
            } else {
                //console.log("checkPeriodOptions - else")
                return canUpdateBasket;
            }
        };

        if (isPhysicalProduct) {
            // Physical products
            //console.log("Physical product");
            if (!basketVersionOfProduct) {
                return putInBasket;
            }
            return basketVersionOfProduct.Count != this.props.amount ? canUpdateBasket : inBasket;
        } else {
            // License product (school/class/teacher or single user)
            //console.log("License product (school/class/teacher or single user)");

            if (currentPriceConfig.ShowClassOptions) {
                // Has CLASS OPTIONS
                //console.log("License product - CLASS OPTIONS");

                const currentClassesValue = currentPriceConfig ? currentPriceConfig.ClassOptions.Options : [];
                const selectedClasses =
                    currentClassesValue && priceConfigUtils.classesSelectedArray(currentClassesValue);
                const sameClassesInBasket =
                    selectedClasses &&
                    priceConfigUtils.sameClassesSelected(basketVersionOfProduct.Classes, currentClassesValue);

                if (selectedClasses && selectedClasses.length < 1) {
                    // No classes selected
                    return noClassesSelected;
                } else if (!currentProduct.IsInBasket) {
                    // Not in basket
                    return putInBasket;
                } else if (sameAccessFormInBasket && sameClassesInBasket) {
                    // Same selection as in basket
                    return inBasket;
                } else {
                    return canUpdateBasket;
                }
            } else if (hasPeriodOptions) {
                // Has PERIOD OPTIONS
                //console.log("License product - PERIOD OPTIONS");
                return checkPeriodOptions();
            } else if (currentPriceConfig.IsSchoolLicenseAndRelevantClasses) {
                // Has RELEVANT CLASSES
                //console.log("License product -  RELEVANT CLASSES");

                if (!currentProduct.IsInBasket) {
                    // Not in basket
                    return putInBasket;
                } else if (currentPriceConfig.AccessFormCode == basketVersionOfProduct.AccessFormCode) {
                    // Same selection as in basket
                    return inBasket;
                } else {
                    return canUpdateBasket;
                }
            } else {
                // School-, class- or single-user-license (NO Class options / NO Period options / NO Relevant classes)
                //console.log("License product - BUT NO Class-options/Period-options/Relevant Classes");
                if (!currentProduct.IsInBasket) {
                    // Not in basket
                    //console.log("Not in basket");
                    return putInBasket;
                } else if (currentPriceConfig.AccessFormCode == basketVersionOfProduct.AccessFormCode) {
                    // Same selection as in basket
                    //console.log("Same selection as in basket");
                    if (
                        currentPriceConfig.AllowQuantity &&
                        basketVersionOfProduct.Count != this.props.amount
                    ) {
                        // Same selection as in basket - but count has changed
                        //console.log("Same selection as in basket - but count has changed");
                        return canUpdateBasket;
                    }
                    return inBasket;
                } else {
                    // Is in basket, but NOT same accessFormCode E.g. School license (All students + all employees) - not in basket - not a count change
                    //console.log("Is in basket, but NOT same accessFormCode");
                    return canUpdateBasket;
                }
            }
        }
    }

    /* Save added product to local storage before login */
    onLoginAndAddToBasket() {
        const currentPriceConfig =
            this.props.currentProduct.PriceConfigurations[this.props.salesConfigIndex] || false;

        const currentClassesValue = currentPriceConfig ? currentPriceConfig.ClassOptions.Options : [];

        localStorage.setItem(
            ADD_TO_BASKET_LOCALSTORAGE_KEY,
            JSON.stringify({
                amount: this.props.amount,
                product: this.props.currentProduct,
                periodValueIndex: this.props.periodValueIndex,
                salesConfigIndex: this.props.salesConfigIndex,
                classesValue: currentClassesValue,
                workId: this.props.work.Id
            })
        );

        this.props.userLogin();
    }

    render() {
        //product and priceconfigs
        const currentProduct = this.props.currentProduct;
        const configIndex =
            currentProduct.PriceConfigurations && currentProduct.PriceConfigurations.length > 1
                ? this.props.salesConfigIndex
                : 0;
        const currentPriceConfig = currentProduct.PriceConfigurations[configIndex] || false;
        const isPhysicalProduct = currentPriceConfig.AccessFormCode == 0;
        const hasPriceConfiguration = currentProduct.PriceConfigurations.length > 0;

        //ready based on basket
        const basketVersionOfProduct = this.productInBasket(currentProduct.Id);
        const basketButtonState =
            this.getUpdateInButtonState(currentProduct, basketVersionOfProduct, currentPriceConfig) || {};

        const renderHelpConsoleForDevelopment = () => {
            return (
                <div className="pptest">
                    <span>Current product:</span>
                    <br />
                    Id:{" "}
                    {currentProduct.Id ? <span>{currentProduct.Id}</span> : <span>false/null/undefined</span>}
                    <br />
                    IsInBasket:{" "}
                    {currentProduct.IsInBasket || (isPhysicalProduct && basketVersionOfProduct) ? (
                        <span className="u-text-green">true</span>
                    ) : (
                        <span className="u-text-red">false</span>
                    )}
                    <hr />
                    <p>
                        Current PriceConfiguration[<span className="u-text-green">{configIndex}</span>]{" "}
                    </p>
                    <p>
                        SalesFormCode:{" "}
                        <span className="u-text-green">{currentPriceConfig.SalesFormCode}</span>
                    </p>
                    <p>
                        AccessFormCode:{" "}
                        <span className="u-text-green">{currentPriceConfig.AccessFormCode}</span>
                    </p>
                    IsInBasket:{" "}
                    {this.props.work &&
                    this.props.work.Products[this.props.currentProductIndex].IsInBasket ? (
                        <span className="u-text-green">true</span>
                    ) : (
                        <span className="u-text-red">false</span>
                    )}
                    <br />
                    IsBuyable:{" "}
                    {currentPriceConfig.IsBuyable ? (
                        <span className="u-text-green">true</span>
                    ) : (
                        <span className="u-text-red">false</span>
                    )}
                    <br />
                    {currentPriceConfig.ShowClassOptions ? (
                        <div>
                            ShowClassOptions:
                            <span className="u-text-green">true</span>
                            <br />
                            ClassOptions.Label:
                            <span className="u-text-green">{currentPriceConfig.ClassOptions.Label}</span>
                            <br />
                            ClassOptions.Options.length:
                            <span className="u-text-green">
                                {currentPriceConfig.ClassOptions.Options.length}
                            </span>
                            <br />
                        </div>
                    ) : (
                        <div>
                            ShowClassOptions: <span className="u-text-red">false</span>
                        </div>
                    )}
                    {currentPriceConfig.PeriodOptions ? (
                        <div>
                            {" "}
                            PeriodOptions:
                            <button
                                type="button"
                                className="link-button"
                                onClick={() => {
                                    alert(JSON.stringify(currentPriceConfig.PeriodOptions));
                                }}
                            >
                                Show json
                            </button>
                        </div>
                    ) : (
                        <div>
                            {" "}
                            PeriodOptions: <span className="u-text-red">false</span>
                        </div>
                    )}
                    ShouldLogin:{" "}
                    {currentPriceConfig.ShouldLogin ? (
                        <span className="u-text-green">true</span>
                    ) : (
                        <span className="u-text-red">false</span>
                    )}
                    <br />
                    Selected:{" "}
                    {currentPriceConfig.Selected ? (
                        <span className="u-text-green">true</span>
                    ) : (
                        <span className="u-text-red">false</span>
                    )}
                    <br />
                    AllowQuantity:{" "}
                    {currentPriceConfig.AllowQuantity ? (
                        <span className="u-text-green">true</span>
                    ) : (
                        <span className="u-text-red">false</span>
                    )}
                    <br />
                    BuyableNote:{" "}
                    {currentPriceConfig.BuyableNote ? (
                        <span>{currentPriceConfig.BuyableNote}</span>
                    ) : (
                        <span className="u-text-red">null</span>
                    )}
                    <br />
                    ProductInfoText:{" "}
                    {currentProduct.ProductInfoText ? (
                        <span>{currentProduct.ProductInfoText}</span>
                    ) : (
                        <span className="u-text-red">null</span>
                    )}
                    <br />
                    <button
                        type="button"
                        className="link-button"
                        onClick={() => {
                            alert(JSON.stringify(currentPriceConfig));
                        }}
                    >
                        Show config json
                    </button>
                </div>
            );
        };

        return (
            <div className="product-picker">
                <div className="product-picker__trumpet">{this.props.Labels.VariantsLabel}</div>
                <ProductPickerRadioSelect
                    Work={this.props.work}
                    labels={this.props.Labels.ProductPickerLabels}
                    current={this.props.currentProductIndex}
                    onChange={this.onChangeHandler}
                    setAmount={this.props.setAmount}
                    amount={this.props.amount}
                />

                {currentProduct.PriceConfigurations.length > 0 && !currentProduct.HideConfigurationDetails && (
                    <div className="product-picker__item__info">
                        <ProductPickerSelectedTypelist
                            product={currentProduct}
                            labels={this.props.Labels.ProductPickerLabels}
                        />
                    </div>
                )}

                {currentPriceConfig.IsBuyable && (
                    <div className="product-picker__total">
                        {currentPriceConfig.DiscountedPrice && (
                            <div className="discounted product-picker--primary-text product-picker__total-primary">
                                <span>{currentPriceConfig.PrimaryPriceText}</span>
                                {this.props.isGettingProductPrice ? (
                                    <div className="loader">
                                        <span></span>
                                    </div>
                                ) : (
                                    <div>
                                        <p className="product-picker__item__price-primary product-picker--primary-text">
                                            {currentPriceConfig.PrimaryPrice}
                                        </p>
                                        {currentPriceConfig.DiscountedPrice && (
                                            <p className="product-picker__item__price-discount">
                                                {currentPriceConfig.DiscountedPrice}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                        {!currentPriceConfig.DiscountedPrice && (
                            <div className="product-picker--primary-text product-picker__total-primary">
                                <span>{currentPriceConfig.PrimaryPriceText}</span>
                                {this.props.isGettingProductPrice ? (
                                    <div className="loader">
                                        <span></span>
                                    </div>
                                ) : (
                                    <div>
                                        <p className="product-picker__item__price-primary product-picker--primary-text">
                                            {currentPriceConfig.PrimaryPrice}
                                        </p>
                                    </div>
                                )}
                            </div>
                        )}
                        <p className="product-picker__note product-picker__total-secondary">
                            {currentPriceConfig.SecondaryPrice}
                        </p>
                        {isPhysicalProduct && this.props.Work.ProductDeliveryInfo && (
                            <DeliveryCostsModalButton
                                isTotalButton={true}
                                productDeliveryInfo={this.props.Work.ProductDeliveryInfo}
                            />
                        )}
                    </div>
                )}

                {currentPriceConfig.AccessFormCode === SINGLE_USER_LICENSE_CODE ? (
                    <div className="product-picker__buttons">
                        {currentPriceConfig.ShouldLogin && !this.props.loggedIn ? (
                            <button
                                type="button"
                                className="button button--slim button--wide"
                                onClick={() => this.toggleLoginModal(true)}
                            >
                                {basketButtonState.label}
                            </button>
                        ) : (
                            <SpinnerButton
                                className="button button-primary button--slim button--wide"
                                label={basketButtonState.label}
                                disabled={this.isLoading() || basketButtonState.disabled}
                                isLoading={this.isLoading()}
                                onClick={this.submitHandler}
                            />
                        )}
                    </div>
                ) : (
                    <div className="product-picker__buttons">
                        {currentPriceConfig.ShouldLogin && !this.props.loggedIn ? (
                            <button
                                type="button"
                                className="button button--slim button--wide button-secondary"
                                onClick={() => {
                                    this.props.userLogin();
                                }}
                            >
                                {basketButtonState.label}
                            </button>
                        ) : (
                            <div>
                                {currentPriceConfig.IsBuyable && (
                                    <div>
                                        {currentProduct.IsInBasket ||
                                        (basketVersionOfProduct && isPhysicalProduct) ? (
                                            <SpinnerButton
                                                className="button button-secondary button--slim button--wide"
                                                label={basketButtonState.label}
                                                disabled={this.isLoading() || basketButtonState.disabled}
                                                isLoading={this.isLoading()}
                                                onClick={this.submitHandler}
                                            />
                                        ) : (
                                            <SpinnerButton
                                                className="button button-primary button--slim button--wide"
                                                label={basketButtonState.label}
                                                disabled={this.isLoading() || basketButtonState.disabled}
                                                isLoading={this.isLoading()}
                                                onClick={this.submitHandler}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}

                        {this.props.showAddTodoButton && (
                            <button
                                className="button button--slim button--wide button-hollow"
                                onClick={() => {
                                    tracking.growthHackTracking("TodoListClick");
                                    this.setState({ ghModalOpen: true });
                                }}
                            >
                                Tilføj til huskeliste
                            </button>
                        )}
                    </div>
                )}

                {currentProduct.ProductInfoText && hasPriceConfiguration && (
                    <div className="product-picker__notification-container">
                        <NoticeList noticeArray={[currentProduct.ProductInfoText]} noIcon />
                    </div>
                )}
                <Modal
                    isOpen={this.state.ghModalOpen}
                    toClose={() => {
                        this.setState({ ghModalOpen: false });
                    }}
                    showCloseButton
                >
                    <div
                        className="article-content"
                        style={{
                            margin: "auto"
                        }}
                    >
                        {/*
                            This is temporary code that will be removed once GrowthHacking is finished
                            - that's why there is no string from Sitecore
                        */}
                        <p className="u-text-align-center">
                            Vi er ved at undersøge behovet for en huskeliste – så tak fordi at du klikkede på
                            linket. Hvis interessen for en huskeliste er stor, så udvikler vi denne funktion
                            meget snart!
                        </p>
                    </div>
                </Modal>
                {false && renderHelpConsoleForDevelopment()}

                <LoginModal
                    labels={{
                        CreateProfileButtonText: this.props.LoginModal.Labels.CreateProfileButtonText,
                        LoginButtonText: this.props.LoginModal.Labels.LoginButtonText,
                        LoginIntroText: this.props.LoginModal.Labels.LoginIntroText
                    }}
                    isOpen={this.state.loginModalOpen}
                    onLoginClick={this.onLoginAndAddToBasket}
                    onClose={() => this.toggleLoginModal(false)}
                    CreateProfileUrl={this.props.LoginModal.CreateProfileUrl}
                />
            </div>
        );
    }
}

export default ProductPicker;
